// Frontend/geniac/src/api/promoCodes.ts
import api from './client';

export interface PromoCode {
  id: string;
  code: string;
  description: string;
  discount_type: 'percentage' | 'fixed_amount';
  discount_value: number;
  currency: string;
  stripe_coupon_id: string | null;
}

export interface PromoCodeValidation {
  valid: boolean;
  error?: string;
  promo_code?: PromoCode;
  discount?: {
    amount: number;
    original_amount: number;
    final_amount: number;
    currency: string;
  };
}

/**
 * Valider un code promo
 */
export async function validatePromoCode(
  code: string,
  plan: string,
  amount: number
): Promise<PromoCodeValidation> {
  try {
    const response = await api.post('/api/promo-codes/validate', {
      code,
      plan,
      amount
    });
    return response.data;
  } catch (error: any) {
    if (error.response?.data) {
      return {
        valid: false,
        error: error.response.data.error || error.response.data.message || 'Code promo invalide'
      };
    }
    throw error;
  }
}

/**
 * Créer un code promo (admin uniquement)
 */
export async function createPromoCode(promoData: any): Promise<any> {
  const response = await api.post('/api/promo-codes', promoData);
  return response.data;
}

/**
 * Lister tous les codes promo (admin uniquement)
 */
export async function listPromoCodes(): Promise<PromoCode[]> {
  const response = await api.get('/api/promo-codes');
  return response.data.promo_codes;
}

/**
 * Désactiver un code promo (admin uniquement)
 */
export async function deactivatePromoCode(id: string): Promise<void> {
  await api.delete(`/api/promo-codes/${id}`);
}

export default {
  validatePromoCode,
  createPromoCode,
  listPromoCodes,
  deactivatePromoCode
};
